import React, {FC} from 'react';
import styled from 'styled-components';

import {ChannelModel} from '../../../../libs/shared/core/src/models/api/channelModel';
import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {maybeRenderAccessory} from './settingsSearchAccessoryHelpers';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownChannelItemProps extends SettingsSearchDropdownItemBaseProps {
  channel: ChannelModel;
  team?: TeamModel;
}

/*
 * Style.
 */

interface ChannelIconStyleProps {
  channelIcon: string;
}
const StyledChannelIconDiv = styled.div<ChannelIconStyleProps>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-image: url(${(p) => p.channelIcon});
  background-size: 32px 32px;
  background-position: center;
`;

/*
 * Component.
 */

export const SettingsSearchDropdownChannelItem: FC<SettingsSearchDropdownChannelItemProps> = (props) => {
  const {channel, team, onSelect} = props;
  const channelIcon = `/views/assets/channels/icon40/${channel.type}.svg`;

  return (
    <SettingsSearchDropdownItem checkmarkLabel={channel.displayName} onSelect={onSelect}>
      <SettingsSearchDropdownItemLeftIcon>
        <StyledChannelIconDiv channelIcon={channelIcon} />
      </SettingsSearchDropdownItemLeftIcon>
      <SettingsSearchDropdownContent>
        <SettingsSearchDropdownTitle>
          {channel.displayName}
          {maybeRenderAccessory(channel, team)}
        </SettingsSearchDropdownTitle>
        <SettingsSearchDropdownSubtitle>{channel.type}</SettingsSearchDropdownSubtitle>
      </SettingsSearchDropdownContent>
    </SettingsSearchDropdownItem>
  );
};
